import { DesktopDatePicker, DatePicker } from "@mui/x-date-pickers";
import React, { useContext } from "react";
import classNames from "classnames";
import {
  createTheme,
  Link,
  ThemeProvider,
} from "@mui/material";
import styles from "./DatePickersForTableHeader.module.css";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";
import { format } from "date-fns";
import { FMSThemeContext } from "contexts/FMSThemeContext";


interface IDatePickersForTableHeadersProps {
  selectedDate: Date;
  selectedDateFrom: Date | null;
  selectedDateTo: Date | null;
  handleDateChangeFrom: (date: Date | null) => void;
  handleDateChangeTo: (date: Date | null) => void;
  handleDateChange: (date: Date | null) => void;
  hideCentralDatePicker?: boolean;
  fromToClassName?: string;
  centralDatePickerFormat?: "month" | "date";
  disableFuture?: boolean;
}

export const DatePickersForTableHeaders: React.FC<
  IDatePickersForTableHeadersProps
> = (props) => {
  const { primaryColor, primaryTextColor } = useContext(FMSThemeContext);
  const materialTheme = createTheme({
    palette: {
      primary: {
        main: primaryColor,
        contrastText: primaryTextColor,
      },
    },
  });

  const {
    selectedDate,
    selectedDateFrom,
    selectedDateTo,
    handleDateChange,
    handleDateChangeFrom,
    handleDateChangeTo,
    hideCentralDatePicker,
    fromToClassName,
    centralDatePickerFormat = "date",
    disableFuture = true,
  } = props;
  const history = useHistory();
  const location = useLocation();
  const currentPath = location.pathname;
  const params = queryString.parse(location.search);
  return (
    <>
      <div className={fromToClassName ?? styles.fromTo}>
          <ThemeProvider theme={materialTheme}>
            <DesktopDatePicker
              enableAccessibleFieldDOMStructure={false}
              views={["day"]}
              value={selectedDateFrom}
              onChange={(startDate) => {
                if (startDate != null) {
                  params.startDate = format(startDate, "yyyy-MM-dd");
                  history.push({
                    pathname: currentPath,
                    search: queryString.stringify(params),
                  });
                }
                handleDateChangeFrom(startDate);
                if (selectedDateTo) {
                  handleDateChange(null);
                }
              }}
              disableFuture={disableFuture}
              format="MMM dd"
              slotProps={{
                textField: {
                  variant: "outlined",
                  placeholder: "From",
                  InputProps: {
                    className: classNames(styles.input, styles.widthDates),
                  },
                },
              }}
            />
            <DesktopDatePicker
              enableAccessibleFieldDOMStructure={false}
              views={["day"]}
              value={selectedDateTo}
              onChange={(endDate) => {
                if (endDate != null) {
                  params.endDate = format(endDate, "yyyy-MM-dd");
                  history.push({
                    pathname: currentPath,
                    search: queryString.stringify(params),
                  });
                }
                handleDateChangeTo(endDate);
                if (selectedDateFrom) {
                  handleDateChange(null);
                }
              }}
              disableFuture={disableFuture}
              format="MMM dd"
              slotProps={{
                textField: {
                  variant: "outlined",
                  placeholder: "To",
                  InputProps: {
                    className: classNames(styles.input, styles.widthDates),
                  },
                },
              }}
            />
          </ThemeProvider>

        <Link
          className={styles.clearButton}
          href="#"
          onClick={() => {
            handleDateChangeFrom(null);
            handleDateChangeTo(null);
            params.startDate = null;
            params.endDate = null;
            history.push({
              pathname: currentPath,
              search: queryString.stringify(params, { skipNull: true }),
            });
            handleDateChange(new Date());
          }}
        >
          Clear
        </Link>
      </div>
      {!hideCentralDatePicker && (
          (<ThemeProvider theme={materialTheme}>
            <DatePicker
              enableAccessibleFieldDOMStructure={false}
              views={
                centralDatePickerFormat === "month"
                  ? ["year", "month"]
                  : undefined
              }
              value={selectedDate}
              openTo={centralDatePickerFormat === "date" ? "day" : centralDatePickerFormat}
              disableFuture={disableFuture}
              format={
                centralDatePickerFormat === "date" ? "dd MMM yyyy" : "MMM yyyy"
              }
              onChange={(date) => {
                handleDateChangeFrom(null);
                handleDateChangeTo(null);
                history.push({
                  pathname: currentPath,
                });
                handleDateChange(date);
              }}
              slotProps={{
                textField: {
                  variant: "standard",
                  InputProps: {
                    className: styles.mainDate,
                  },
                  style: { float: "left", left: "15%", width: "150px" },
                },
              }}
            />
          </ThemeProvider>)
      )}
    </>
  );
};
